import { RewardActivityStatusResponse } from '../../../queries/types';

export const getRewardActivityStatusModel = (
  response: RewardActivityStatusResponse
): RewardActivityStatusResponse => response;
